import { apiClient } from "./useApi"
import type { McoEndpointBuilder } from "./apiSlice"
import { ApiTag } from "./util/ApiTag"

const auditEndpoints = (build: McoEndpointBuilder) => ({
	auditGetEvents: build.query({
		queryFn: apiClient.audit.getAuditEvents,
		providesTags: [ApiTag.Tenant, ApiTag.Audit]
	}),
	auditGetTypes: build.query({
		queryFn: (_: void) => apiClient.audit.getAuditTypes(),
		providesTags: [ApiTag.Tenant, ApiTag.Audit]
	})
})

export default auditEndpoints
